import { API, graphqlOperation } from "aws-amplify";
export default class HealthAssessment {
  constructor(filter) {
    this._filter = filter;
    this._nextToken = null;
    this._graphDataRaw = null;
    this._graphDataFiltered = null;
  }

  getGraphData() {
    const that = this;
    return new Promise(async function (resolve) {
      let results = await that.getHealthAssessmentData();
      that._graphDataRaw = results;
      that._graphDataFiltered = that.filterData(results);

      while (that._nextToken !== null) {
        let nextResultSet = await that.getHealthAssessmentData();
        that._graphDataRaw.push(...nextResultSet);
        that._graphDataFiltered.push(...that.filterData(nextResultSet));
      }
      resolve(that._graphDataRaw);
    });
  }

  async getHealthAssessmentData() {
    const listSurveyHealthAssessments = /* GraphQL */ `
      query ListSurveyHealthAssessments(
        $filter: ModelSurveyHealthAssessmentFilterInput
        $limit: Int
        $nextToken: String
      ) {
        listSurveyHealthAssessments(
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            survey
            companyId
            companyName
            subjectId
            testId
            consultant
            surveyTemplate
            gender
            testDate
            bookingExperience
            onTime
            discussResults
            lifestyleChange
            professionalism
            experience
            recommend
            participate
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    `;
    let gqlConfig = {
      nextToken: this._nextToken,
      limit: 2000,
    };
    if (this._filter) {
      gqlConfig = {
        filter: this._filter,
        nextToken: this._nextToken,
        limit: 2000,
      };
    }

    const {
      data: { listSurveyHealthAssessments: results }
    } = await API.graphql(
      graphqlOperation(listSurveyHealthAssessments, gqlConfig)
    );
    this._nextToken = results.nextToken;
    return results.items;
  }

  filterData(data) {
    return data.filter(function(result) {
      return result.bookingExperience !== null;
    });
  }

  getFilteredData() {
    return this._graphDataFiltered;
  }

  getRawData() {
    return this._graphDataRaw;
  }

  getUniqueCompanyNames() {
    const data = this.getRawData();
    const uniqueColumn = data.map(function (value) {
      return value.companyName.trim();
    });

    let uniqueArray = [...new Set(uniqueColumn)];
    return uniqueArray.sort();
  }

  getUniqueConsultants() {
    const data = this.getRawData();
    const uniqueColumn = data.map(function (value) {
      if (value.consultant) {
        return value.consultant.trim();
      }
    });
    let uniqueArray = [...new Set(uniqueColumn)];
    return uniqueArray.sort();
  }
}
